export default "__VITE_ASSET__aecdb3b6__"